module.exports = __webpack_public_path__ + "static/media/file2.97eabd1c.png";